module.exports = __webpack_public_path__ + "img/createorder.7fbe5676.svg";